// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag--3bGz3","Col":"Col--1cC99"};